import { useLoginModal } from '@/hooks/use-login-modal'

const Login = () => {
  const { openLoginModal } = useLoginModal()
  return (
    <div className="mx-3 fc">
      <div
        className="h-30px w-80px fcc cursor-pointer rounded-8 bg-#00747419 text-14px text-#007474"
        onClick={openLoginModal}
      >
        登录
      </div>
    </div>
  )
}
export default Login
